export default class AemConfigurations {
  static set(data) {
    this.configuration = data;
  }
  static get(key = null) {
    if (!this.configuration?.[key]) {
      return null;
    }
    return key === null ? this.configuration : this.configuration[key];
  }
  static getPrivacyPath(key, lang) {
    if (!this.configuration.privacyPaths || !this.configuration.privacyPaths[key] || !this.configuration.privacyPaths[key][lang]) {
      return null;
    }
    return this.configuration.privacyPaths[key][lang];
  }
  static getAll() {
    return this.configuration;
  }
}
